import { CalEventStatus } from '../constants/cal-event-status.js';
/** True once the event has moved past the point where this gate may change. */
export function isCalEventGateLocked(event, gate) {
    switch (gate) {
        case 'needsApproval':
            return (event.statusId !== CalEventStatus.SCHEDULED ||
                event.approvedAt !== null ||
                event.calEventAssignees.some((assignee) => assignee.confirmedAt !== null));
        case 'checkInRequired':
            return (event.statusId !== CalEventStatus.SCHEDULED ||
                event.calEventAssignees.some((assignee) => assignee.checkedInAt !== null));
        default:
            return event.statusId === CalEventStatus.UNDER_REVIEW;
    }
}
//# sourceMappingURL=is-cal-event-gate-locked.js.map